import {Modal} from '@forecast-it/design-system';

interface DeleteTicketModalProps {
	open: boolean;
	ticketSlug: string;
	ticketSubject?: string;
	loading: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export function DeleteTicketModal({open, ticketSlug, ticketSubject, loading, onConfirm, onCancel}: DeleteTicketModalProps) {
	if (!open) return null;

	// Naming the subject as well as the slug is what makes this confirmable: a slug alone
	// is easy to mistake for a neighbouring ticket's.
	const label = ticketSubject ? `${ticketSlug} — ${ticketSubject}` : ticketSlug;

	return (
		<Modal onCloseModal={onCancel}>
			<Modal.Title>Delete ticket</Modal.Title>
			{/* Modal.Content is a flex column, so every child of it becomes its own stacked
			    line. The sentence has to arrive as a single child to read as one sentence. */}
			<Modal.Content>
				<span>
					Are you sure you want to delete <strong>{label}</strong>? This action cannot be undone.
				</span>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onConfirm} disabled={loading}>
					{loading ? 'Deleting…' : 'Delete'}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={onCancel} disabled={loading}>
					Cancel
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
}
